import * as Yup from 'yup'
import { NOTIFICATION_PROVIDERS } from 'domains/announcements/constants'

export const notificationTemplateWhatsappSchema = () => {
  let notificationTemplateWhatsappSchema = Yup.object().shape({
    whatsapp: Yup.object().shape({
      provider: Yup.string()
        .required('Required'),

      namespace: Yup.string()
        .when('provider', {
          is   : (provider) => provider === NOTIFICATION_PROVIDERS.FRESHCHAT.value,
          then : Yup.string()
            .required('Required')
        }),
      name: Yup.string()
        .required('Required'),

      body: Yup.string()
        .required('Required'),

      has_image: Yup.boolean()
        .required('Required')
    })

  })

  return notificationTemplateWhatsappSchema
}

export const notificationTemplateSchema = (hasWhatsapp) => {
  let notificationTemplateSchema = Yup.object().shape({
    name: Yup.string()
      .required('Required'),

    description: Yup.string()
      .required('Required'),

    has_push_notif: Yup.boolean()
      .required('Required'),

    tinkerlust: Yup.object().shape({
      title: Yup.string()
        .required('Required'),

      body: Yup.string()
        .required('Required'),

      direct_url: Yup.string()
        .matches(/^\S*$/, 'url tidak boleh mengandung spasi')
        .required('Required')
    })
  })

  if (hasWhatsapp) {
    notificationTemplateSchema = notificationTemplateSchema.concat(notificationTemplateWhatsappSchema())
  }

  return notificationTemplateSchema
}
